<template>
  <a-modal title="" class="after-sales-module" :visible="visible" @ok="onCofrim" @cancel="handleCancel">
    <div class="after-sales-box">
        <a-row style="margin-bottom: 8px;">
            <a-col class="title">需退货数量：</a-col>
            <a-col class="content content-number">
                <span class="btn-number" @click="btnAddNumber">➕</span>
                <a-input placeholder="" v-model="formData.returnCount" @change="setNumbaer" class="number-input"/>
                <span class="btn-number" @click="btnReductionNumber">➖</span>
            </a-col>
        </a-row>
        <a-row>
            <a-col class="title">预计退款金额：</a-col>
            <a-col class="content">{{ formData.returnMoney }}</a-col>
        </a-row>
        <a-row>
            <a-col style="color: #FF0000">注意：只能发起一次售后，请先和客户确认售后需求</a-col>
        </a-row>
    </div>
  </a-modal>
</template>
<script>
export default {
  name: "afterSalesModule",
  components: {},
  data() {
    return {
      visible: false,
      data: {},
      formData: {
        itemId: null,
        returnCount: 1,
        returnMoney: 0,
        price: null
      }
    };
  },
  methods: {
    open(record) {
      this.data = record
      this.formData.itemId = record.id
      this.formData.price = record.price
      this.formData.returnCount = record.productTotalCount
      this.formData.returnMoney = record.productTotalCount * record.price
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    onCofrim() {
      this.visible = false;
      this.$emit("btnItemAfterSales",this.formData);
    },
    btnAddNumber() {
      if(this.formData.returnCount < this.data.productTotalCount) {
        this.formData.returnCount = Number(this.formData.returnCount) + 1
        this.formData.returnMoney = this.formData.returnCount * this.formData.price
      } else {
        this.$message.warning('输入退货商品数量已大于该商品在订单中的数量')
      }
    },
    btnReductionNumber() {
      if(this.formData.returnCount >= 1) {
        this.formData.returnCount = Number(this.formData.returnCount) - 1
        this.formData.returnMoney = this.formData.returnCount * this.formData.price
      } else {
        this.$message.warning('请输入大于 1 的退货商品数量')
      }
    },
    setNumbaer() {
      this.formData.returnMoney = this.formData.returnCount * this.formData.price
    }
  },
  watch: {},
};
</script>
<style lang="scss">
.after-sales-module {
  width: 520px !important;
  .after-sales-box {
    padding: 40px 50px 20px 50px;
    .ant-row {
        height: 36px;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        .content-number {
            height: 36px;
            display: flex;
            align-items: center;
            .number-input {
                width: 94px; 
                height: 36px;
                margin: 0 8px
            }
            .btn-number {
                display: inline-block;
                width: 28px;
                height: 28px;
                background: #FFFFFF;
                border: 1px solid #DDDDDD;
                border-radius: 50%;
                line-height: 28px;
                text-align: center;
                cursor: pointer;
            }
        }
    }
  }
  .ant-table-wrapper {
    border: 1px solid #f0f0f0;
    border-bottom: 0;
  }
  .ant-modal-footer {
    padding: 0 0 48px 0;
  }
}
</style>
